module.exports = __webpack_public_path__ + "static/app-shot-1-1-3f096d4b1b4b52d524e829227838bbb4.jpg";